<div class="bg-white m-2">
  <div class="border-bottom border-gray">
    <button type="button" class="btn btn-icons float-start mt-0" aria-label="Close" (click)="refuse()">
      <span aria-hidden="true">&times;</span>
    </button>
    <h3 class="text-center text-secondary py-2 pe-5">Confirmation</h3>
  </div>
  <div class="modal-body">
    <div class="row">
      <p class="col-12 text-secondary">{{ question }}</p>
      <div class="d-grid col-6 p-0 pe-1">
        <button class="btn btn-primary d-flex justify-content-center" type="button" (click)="accept()">Oui</button>
      </div>
      <div class="d-grid col-6 p-0 ps-1">
        <button class="btn btn-secondary d-flex justify-content-center" type="button" (click)="refuse()">Non</button>
      </div>
    </div>
  </div>
</div>
